export default {
  title: 'Message processing'
}
